import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { PlanService } from 'src/app/services/actions/plan.service';

@Component({
  selector: 'app-carrinho-plano',
  templateUrl: './carrinho-plano.component.html',
  styleUrls: ['./carrinho-plano.component.scss']
})
export class CarrinhoPlanoComponent implements OnInit {
  paymentForm = new FormGroup({
    paymentMethod: new FormControl(),
    planTypeId: new FormControl(),
    cardHolderName: new FormControl(),
		cardNumber: new FormControl(),
		cardExpirationDate: new FormControl(),
		cardCvv: new FormControl()
  })

  plan
  planTypeId
  paymentMethodChosen = ''
  plansTimes = {
    1: {
      number: 1,
      period: 'months'
    },
    2: {
      number: 6,
      period: 'months'
    },
    3: {
      number: 12,
      period: 'months'
    },
    4: {
      number: 5,
      period: 'months'
    }
  }
  beginEndPlan = {}
  paymentData = {}
  chargeAmount = true
  showPaymentData = false
  displayModal = false
  displayStyleBlock = 'none'

  constructor(
    private route: ActivatedRoute,
    private planService: PlanService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit () {
    this.planTypeId = this.route.snapshot.queryParams['plan_type']
    this.getPlanByTypeId(this.planTypeId)
  }

  getPlanByTypeId (typeId) {
    this.planService
			.getPlanByTypeId(typeId)
			.subscribe(
				(res) => {
          if (res['plan']) {
            this.plan = res['plan']
            if (this.plan['value'] === 0) {
              this.chargeAmount = false
              this.calcPlanTime()
            }
          }
				},
				(err) => {
					console.log(err);
				}
			);
  }

  voltar () {
    window.history.back()
  }

  onItemChange(value){
    this.paymentMethodChosen = value
    this.calcPlanTime()
  }

  calcPlanTime () {
    const timePlan = this.plansTimes[this.plan['id']]
    this.beginEndPlan = {
      begin: moment().format('DD/MM/YYYY'),
      end: moment().add(timePlan.number, timePlan.period).format('DD/MM/YYYY')
    }
  }

  openPopup() {
    this.displayModal = true
    this.displayStyleBlock = 'block'
  }
  closePopup() {
    this.displayModal = false
    this.displayStyleBlock = 'none'
  }

  confirmPayment () {
    let paymentValues = this.paymentForm.getRawValue();
    paymentValues.planTypeId = this.planTypeId

    if (this.plan['value'] === 0) {
      paymentValues.paymentMethod = 'pix'
    }

    if (paymentValues.paymentMethod === 'card') {
      this.openPopup()
      if (!paymentValues.cardNumber) {
        this.toastr.warning('Número do cartão faltando!')
        return
      }

      if (!paymentValues.cardHolderName) {
        this.toastr.warning('Nome no cartão faltando!')
        return
      }

      if (!paymentValues.cardExpirationDate) {
        this.toastr.warning('Data de Validade faltando!')
        return
      }

      if (!paymentValues.cardCvv) {
        this.toastr.warning('Código Segurança (CVV) faltando!')
        return
      }

      this.planService.newPlanRecurrent(paymentValues).subscribe(
        (res) => {
          this.closePopup()
          this.router.navigate(['/logado/plano'])
          return
        },
        (err) => {
          this.closePopup()
          this.toastr.warning(err.error)
          return
        }
      )
      return
    }
    
    this.planService.newPlan(paymentValues).subscribe(
			(res) => {
        this.paymentData = res
        this.showPaymentData = true
			},
			(err) => {
				console.log(err.error);
				this.toastr.warning('Erro!!!')
			}
		)
   }
}
